import React, { FC, ReactNode, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { RootStore, RootStoreContext } from '../../stores/rootStore';

interface AuthenticatedPageProps {
    children: ReactNode;
}

const AuthenticatedPage: FC<AuthenticatedPageProps> = ({ children }) => {
    const rootStore = useContext(RootStoreContext);
    const userStore = rootStore.userStore;

    if (!userStore.isLoggedIn) {
        userStore.OpenLoginForm();
    }

    return userStore.isLoggedIn
        ? <>{children}</>
        : <div className="page-center"><p>Please sign in to view this page.</p></div>;
};

export default observer(AuthenticatedPage);
